import { Flex } from '@chakra-ui/react'
import React, { useCallback } from 'react'
import InfiniteList from '~/components/InfiniteList'
import { TransferHeader } from '~/pages/WebPhone/TransferHeader'
import { TransferTarget } from '~/pages/WebPhone/TransferTarget'

import { ExtensionPreview } from '@mangovoice/types'

interface TransferControlProps {
  onTransfer: (target: string) => void
  extensions: ExtensionPreview[]
}
export const TransferControl = ({
  onTransfer,
  extensions,
}: TransferControlProps) => {
  const [transferTarget, setTransferTarget] = React.useState('')

  const onTransferTargetChange = (target: string) => {
    setTransferTarget(target)
  }

  const getNumberSortedExtensions = useCallback(() => {
    const filtered = extensions.filter((extension) =>
      extension.number.includes(transferTarget),
    )
    filtered.sort((a, b) => {
      if (a.number < b.number) {
        return -1
      }
      if (a.number > b.number) {
        return 1
      }
      return 0
    })

    return filtered
  }, [extensions, transferTarget])

  return (
    <Flex
      direction="column"
      width="full"
      height="45vh"
      minH="fit-content"
      maxH="100%"
      paddingBottom="12px"
    >
      <TransferHeader
        transferTarget={transferTarget}
        onTransferTargetChange={onTransferTargetChange}
        onTransfer={onTransfer}
      />
      <InfiniteList
        data={getNumberSortedExtensions()}
        listItem={(_, extension: ExtensionPreview) => {
          return (
            <TransferTarget
              id={extension.id}
              number={extension.number}
              name={extension.name}
              onTransfer={onTransfer}
            />
          )
        }}
        style={{ backgroundColor: 'transparent' }}
      />
    </Flex>
  )
}
